import { FC } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import styles from './social-midia.module.css';

export interface IMidia {
  Icon: SvgIconComponent;
  link: string;
}

export interface SocialMidiaProps {
  midiasList: IMidia[];
}

export const SocialMidia: FC<SocialMidiaProps> = ({ midiasList }) => (
  <div className={styles.socialMidia}>
    {midiasList.map(({ link, Icon }, index) => (
      <a
        className={styles.iconContainer}
        href={link}
        target="_blank"
        rel="noreferrer"
        key={index}
        aria-label={`Acesse nosso perfil no ${link}`}
      >
        <Icon className={styles.icon} />
      </a>
    ))}
  </div>
);
